import CurrentTrip from './CurrentTrip';

export default CurrentTrip;
